import type { KeyHandler } from 'hotkeys-js';
import hotkeys from 'hotkeys-js';
import { useCallback, useEffect } from 'react';

type Options = {
  scope?: string;
  element?: HTMLElement | null;
  keyup?: boolean | null;
  keydown?: boolean | null;
  splitKey?: string;
};
interface UseHotKeysArg {
  keys: string;
  options?: Options;
  handler: KeyHandler;
}

export const useHotkeys = ({ keys, handler, options = {} }: UseHotKeysArg, deps: unknown[] = []) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCallback = useCallback(handler, deps);

  useEffect(() => {
    hotkeys(keys, options, memoizedCallback);

    return () => hotkeys.unbind(keys);
  }, [keys, memoizedCallback, options]);
};

export default useHotkeys;
